import React from 'react';

const FooterComponent: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <div className="inline-flex flex-wrap items-center justify-center gap-x-3 gap-y-2">
      <span className="text-xs font-medium leading-snug tracking-wide text-slate-500">
        Version 2.0.0
      </span>
      <span className="select-none text-xs text-slate-400" aria-hidden>
        |
      </span>
      <span className="text-xs font-medium leading-snug tracking-wide text-slate-500">
        &copy; TaskUs @ {year}
      </span>
      <span className="select-none text-xs text-slate-400" aria-hidden>
        |
      </span>
      <a
        href="https://www.taskus.com/security/"
        target="_blank"
        rel="noreferrer"
        className="text-xs font-semibold leading-snug text-slate-600 transition-colors duration-200 hover:text-primary"
      >
        Security
      </a>
    </div>
  );
};

export default FooterComponent;
